import React, { useMemo } from 'react';
import { MBFieldFileBlock } from './fieldFile';

interface Props {
  url: string;
  label?: string;
}

export function MBImageBlock({ url, label }: Props) {
  return (
    <MBFieldFileBlock
      value={useMemo(() => [{ url, name: '', contentType: 'image/unknown' }], [url])}
      label={label}
    />
  );
}
